<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Check Master Status</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row dense justify="center">
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
            item-text="ay" return-object label="Academic Year" outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-btn @click="getData()" :disabled="current_academic_year == null" :loading="loader"
            class="button mt-7 pt-0">Proceed</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="show_table">
      <!-- <div v-for="(s, r, index) in All_Data" :key="index">
        ss-{{ r }} {{ s }} ## {{ s.SerialFieldMasterId }} <br />
        length-- {{ s.length }} // {{ typeof s }} <br />
        <span v-if="typeof s === 'object'">shivvv</span>
      </div> -->

      <v-simple-table fixed-header dense class="elevation-1 mytable" height="500px">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Count</th>
            <th>Serial Field Master Id</th>
            <th>Serial Field Tracking No.</th>
            <th>Serial Field Type Id</th>
          </tr>
        </thead>

        <tbody v-for="(s, r, index) in All_Data" :key="index">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ r }}</td>
            <td>
              <span v-if="typeof s === 'object'">--</span>
              <span v-else> {{ s }}</span>
            </td>
            <td>
              <span v-if="s != null">
                <span v-if="s.SerialFieldMasterId != null">{{
                  s.SerialFieldMasterId
                  }}</span>
                <span v-else> <v-icon color="error">mdi-close</v-icon> </span>
              </span>
              <span v-else> <v-icon color="error">mdi-close</v-icon> </span>
            </td>
            <td>
              <span v-if="s != null">
                <span v-if="s.SerialFieldMasterId != null">
                  {{ s.SerialFieldTrackingNo }}</span>
                <span v-else> <v-icon color="error">mdi-close</v-icon> </span>
              </span>
              <span v-else> <v-icon color="error">mdi-close</v-icon> </span>
            </td>
            <td>
              <span v-if="s != null">
                <span v-if="s.SerialFieldMasterId != null">{{
                  s.SerialFieldTypeId
                  }}</span>
                <span v-else> <v-icon color="error">mdi-close</v-icon> </span>
              </span>
              <span v-else> <v-icon color="error">mdi-close</v-icon> </span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    academic_year_list: null,
    current_academic_year: null,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    loader: false,
    load: true,
    show_table: false,
    All_Data: [],
    // OpenHouse: null,
  }),

  methods: {
    getData() {
      this.loader = true;
      const formData = {
        ay: this.current_academic_year.ay,
        // ay: "2022-23",
      };
      axios
        .post("/admin/checkMasterStatus", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.All_Data = res.data;
            // this.OpenHouse = res.data.OpenHouse;

            this.show_table = true;
          } else {
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.showSnackbar("red", res.data.snackbar);
          }
          this.loader = false;
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong....");
          this.loader = false;
          this.show_table = false;
        })
        .finally(() => {
          //close loader
          this.loader = false;
        });
    },
    get_ay_std() {
      //api-1
      axios
        .post("/InstallmentStructureDetails/getAllData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.ay_data;
            this.current_academic_year = res.data.cay;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.get_ay_std();
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 50%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
thead,
tr,
td,
th {
  /* font-weight: bold !important; */
  border: 1px solid #ccc;
  font-size: large;
}
</style>

